import { useEffect, useState } from "react";
import { api } from "@finance/lib/api";

// Single shared source of truth for the Somcore PO status flow.
// Fetched once from the backend (/meta/status-flow) and cached for the session
// so the filter dropdown and the create/edit form can never drift apart.
let _cache = null;
let _promise = null;

export function useStatusFlow() {
  const [flow, setFlow] = useState(_cache || []);
  useEffect(() => {
    if (_cache) { setFlow(_cache); return; }
    if (!_promise) {
      _promise = api.get("/meta/status-flow").then((r) => { _cache = r.data.flow || []; return _cache; });
    }
    let active = true;
    _promise.then((f) => { if (active) setFlow(f); }).catch(() => {});
    return () => { active = false; };
  }, []);
  return flow;
}
